// Wishlist functionality

window.Wishlist = (function() {

  var STORAGE_KEY = 'pap-wishlist';
  var RECENTLY_KEY = 'pap-recently-viewed';
  var RECENTLY_MAX = 6;

  // --------------------------------------------------
  // Language
  // --------------------------------------------------

  function getWishlistLanguage() {
    var lang = document.documentElement.lang || 'sv';
    lang = lang.toLowerCase().split('-')[0];

    if (lang === 'da') return 'da';
    if (lang === 'no' || lang === 'nb' || lang === 'nn') return 'no';
    if (lang === 'en') return 'en';

    return 'sv';
  }


  // --------------------------------------------------
  // Wishlist storage
  // --------------------------------------------------

  function getAll() {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
    } catch(e) {
      return [];
    }
  }

  function save(items) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
    } catch(e) {}
  }

  function add(product) {
    var items = getAll();

    if (!items.find(function(i) {
      return i.handle === product.handle;
    })) {
      items.push(product);
      save(items);
    }

    update();
  }

  function remove(handle) {
    var items = getAll().filter(function(i) {
      return i.handle !== handle;
    });

    save(items);
    update();
  }

  function toggle(product) {
    if (has(product.handle)) {
      remove(product.handle);
    } else {
      add(product);
    }
  }

  function has(handle) {
    return getAll().some(function(i) {
      return i.handle === handle;
    });
  }

  function clear() {
    save([]);
    update();
  }


  // --------------------------------------------------
  // Recently viewed
  // --------------------------------------------------

  function trackRecentlyViewed(product) {
    try {
      var recent = JSON.parse(localStorage.getItem(RECENTLY_KEY)) || [];

      recent = recent.filter(function(i) {
        return i.handle !== product.handle;
      });

      recent.unshift(product);
      recent = recent.slice(0, RECENTLY_MAX);

      localStorage.setItem(RECENTLY_KEY, JSON.stringify(recent));
    } catch(e) {}
  }

  function getRecentlyViewed() {
    try {
      return JSON.parse(localStorage.getItem(RECENTLY_KEY)) || [];
    } catch(e) {
      return [];
    }
  }

  function renderRecentlyViewed() {
    var container = document.getElementById('recently-viewed');
    var grid = document.getElementById('recently-viewed-grid');

    if (!container || !grid) return;

    var recent = getRecentlyViewed();

    if (recent.length === 0) return;

    container.style.display = 'block';

    grid.innerHTML = recent.map(function(item) {
      return '<a href="/products/' + item.handle + '" style="text-decoration:none; color:inherit;">' +
        '<img src="' + item.image + '" alt="' + item.title + '" style="width:100%; aspect-ratio:1; object-fit:cover; border-radius:2px;">' +
        '<p style="font-size:1.2rem; margin-top:6px; text-align:center;">' + item.title + '</p>' +
        '</a>';
    }).join('');
  }


  // --------------------------------------------------
  // Confirmation popup
  // --------------------------------------------------

  function showConfirm(lang, onConfirm) {
    if (document.querySelector('.wishlist-confirm-overlay')) return;

    var overlay = document.createElement('div');

    overlay.className = 'wishlist-confirm-overlay';

    var removeText =
      lang === 'en' ? 'Remove all favorites?' :
      lang === 'da' ? 'Fjern alle favoritter?' :
      lang === 'no' ? 'Fjern alle favoritter?' :
      'Ta bort alla favoriter?';

    var yesText =
      lang === 'en' ? 'Yes' :
      'Ja';

    var cancelText =
      lang === 'en' ? 'Cancel' :
      lang === 'da' ? 'Annuller' :
      lang === 'no' ? 'Avbryt' :
      'Avbryt';

    overlay.innerHTML = '<div class="wishlist-confirm-box">' +
      '<p>' + removeText + '</p>' +
      '<div class="wishlist-confirm-actions">' +
        '<button class="wishlist-confirm-yes">' + yesText + '</button>' +
        '<button class="wishlist-confirm-no">' + cancelText + '</button>' +
      '</div></div>';

    document.body.appendChild(overlay);

    overlay.querySelector('.wishlist-confirm-yes').addEventListener('click', function() {
      document.body.removeChild(overlay);
      onConfirm();
    }, { once: true });

    overlay.querySelector('.wishlist-confirm-no').addEventListener('click', function() {
      document.body.removeChild(overlay);
    }, { once: true });

    overlay.addEventListener('click', function(e) {
      if (e.target === overlay) {
        document.body.removeChild(overlay);
      }
    }, { once: true });
  }


  // --------------------------------------------------
  // Update
  // --------------------------------------------------

  function update() {

    var items = getAll();
    var count = items.length;

    var badge = document.getElementById('wishlist-badge');

    if (badge) {
      badge.textContent = count;
      badge.style.display = count > 0 ? 'flex' : 'none';
    }

    document.querySelectorAll('.wishlist-btn').forEach(function(btn) {

      var handle = btn.getAttribute('data-handle');

      if (handle) {
        btn.classList.toggle(
          'wishlist-btn--active',
          has(handle)
        );
      }
    });

    var page = document.getElementById('wishlist-page');

    if (page) {
      renderWishlistPage();
    }
  }


  // --------------------------------------------------
  // Wishlist page
  // --------------------------------------------------

  function renderWishlistPage() {

    var items = getAll();

    var container = document.getElementById('wishlist-items');
    var empty = document.getElementById('wishlist-empty');
    var actions = document.getElementById('wishlist-actions');

    if (!container) return;

    if (items.length === 0) {

      container.innerHTML = '';

      if (empty) {
        empty.style.display = 'block';
      }

      if (actions) {
        actions.style.display = 'none';
      }

    } else {

      if (empty) {
        empty.style.display = 'none';
      }

      if (actions) {
        actions.style.display = 'flex';
      }

      container.innerHTML = items.map(function(item) {

        var lang = getWishlistLanguage();

        var addToCartText =
          lang === 'en' ? 'Add to cart' :
          lang === 'da' ? 'Læg i indkøbskurv' :
          lang === 'no' ? 'Legg i handlekurv' :
          'Lägg i varukorg';

        var removeText =
          lang === 'en' ? 'Remove' :
          lang === 'da' ? 'Fjern' :
          lang === 'no' ? 'Fjern' :
          'Ta bort';

        return '<div class="wishlist-item" data-handle="' + item.handle + '">' +

          '<a href="/products/' + item.handle + '" class="wishlist-item__image-link">' +
            '<img src="' + item.image + '" alt="' + item.title + '" class="wishlist-item__image">' +
          '</a>' +

          '<div class="wishlist-item__info">' +
            '<a href="/products/' + item.handle + '" class="wishlist-item__title">' +
              item.title +
            '</a>' +
          '</div>' +

          '<div class="wishlist-item__actions">' +

            '<button class="wishlist-item__add" data-variant="' + item.variant + '">' +
              addToCartText +
            '</button>' +

            '<button class="wishlist-item__remove" data-handle="' + item.handle + '">' +
              removeText +
            '</button>' +

          '</div>' +

        '</div>';

      }).join('');


      // Remove buttons

      container.querySelectorAll('.wishlist-item__remove').forEach(function(btn) {

        btn.addEventListener('click', function() {

          remove(
            btn.getAttribute('data-handle')
          );

        });

      });


      // Add to cart buttons

      container.querySelectorAll('.wishlist-item__add').forEach(function(btn) {

        btn.addEventListener('click', function() {

          var handle = btn.closest('.wishlist-item').getAttribute('data-handle');
          var actionsDiv = btn.parentElement;

          fetch('/products/' + handle + '.js')

            .then(function(r) {
              return r.json();
            })

            .then(function(product) {

              var variants = product.variants;

              actionsDiv.innerHTML =
                variants.map(function(v) {

                  return '<button class="wishlist-item__variant" data-variant="' +
                    v.id +
                    '">' +
                    v.title +
                    '</button>';

                }).join('') +

                '<button class="wishlist-item__cancel">✕</button>';


              // Variant buttons

              actionsDiv.querySelectorAll('.wishlist-item__variant').forEach(function(vBtn) {

                vBtn.addEventListener('click', function() {

                  var variantId = vBtn.getAttribute('data-variant');

                  var lang = getWishlistLanguage();

                  var addingText =
                    lang === 'en' ? 'Adding...' :
                    lang === 'da' ? 'Tilføjer...' :
                    lang === 'no' ? 'Legger til...' :
                    'Lägger till...';

                  vBtn.textContent = addingText;

                  fetch('/cart/add.js', {

                    method: 'POST',

                    headers: {
                      'Content-Type': 'application/json'
                    },

                    body: JSON.stringify({
                      id: variantId,
                      quantity: 1
                    })

                  }).then(function() {

                    window.location.reload();

                  });

                });

              });


              // Cancel variant selection

              actionsDiv.querySelector('.wishlist-item__cancel').addEventListener('click', function() {

                renderWishlistPage();

              });

            });

        });

      });

    }

    renderRecentlyViewed();
  }


  // --------------------------------------------------
  // Add all to cart
  // --------------------------------------------------

  function addAllToCart() {

    var items = getAll();

    var promises = items.map(function(item) {

      if (!item.variant) {
        return Promise.resolve();
      }

      return fetch('/cart/add.js', {

        method: 'POST',

        headers: {
          'Content-Type': 'application/json'
        },

        body: JSON.stringify({
          id: item.variant,
          quantity: 1
        })

      });

    });

    Promise.all(promises).then(function() {

      window.location.href = '/cart';

    });

  }


  // --------------------------------------------------
  // Initialization
  // --------------------------------------------------

  document.addEventListener('DOMContentLoaded', function() {

    update();


    // Track recently viewed on product pages

    var productHandle = document.querySelector('product-info');

    if (productHandle) {

      var handle = productHandle.getAttribute('data-product-handle');
      var title = productHandle.getAttribute('data-product-title');
      var image = productHandle.getAttribute('data-product-image');

      if (handle && title && image) {

        trackRecentlyViewed({
          handle: handle,
          title: title,
          image: image
        });

      }

    }


    // Wishlist page

    var page = document.getElementById('wishlist-page');

    if (page) {

      renderWishlistPage();

      var addAllBtn = document.getElementById('wishlist-add-all');

      if (addAllBtn) {
        addAllBtn.addEventListener('click', addAllToCart);
      }

      var clearBtn = document.getElementById('wishlist-clear');

      if (clearBtn) {

        clearBtn.addEventListener('click', function(e) {

          e.preventDefault();
          e.stopPropagation();

          showConfirm(getWishlistLanguage(), function() {
            clear();
          });

        });

      }

    }


    // Wishlist heart buttons

    document.addEventListener('click', function(e) {

      var btn = e.target.closest('.wishlist-btn');

      if (!btn) return;

      e.stopPropagation();
      e.preventDefault();

      var handle = btn.getAttribute('data-handle');
      var title = btn.getAttribute('data-title');
      var image = btn.getAttribute('data-image');
      var variant = btn.getAttribute('data-variant');

      toggle({
        handle: handle,
        title: title,
        image: image,
        variant: variant
      });

    });

  });


  // Handle browser back/forward cache

  window.addEventListener('pageshow', function(e) {

    if (e.persisted) {
      update();
    }

  });


  return {
    getAll: getAll,
    has: has,
    update: update,
    trackRecentlyViewed: trackRecentlyViewed
  };

})();